const AppName = [
    'devicegroup',
    'networksync',
    'waypoint',
    'AssetGroup',
    'deviceconfig',
    'asset',
    'devicesunloads',
    'recovery',
    'zone',
    'device',
    'devicentp',
    'device_ship',
    'shipping',
    'island',
    'devicesensors',
    'routestatic',
    'routedynamic',
    'firmware',
    'deviceserver',
    'devicemqtt',
    'programming',
    'user',
    'assetgroup',
    'networkconfig',
    'pga460'
];

export default AppName;